import HttpClient from './HttpClient'

export async function fetchHanArchives(slug) {
  const { data } = await HttpClient().get(
    `/api/v1/territory/${encodeURIComponent(slug)}/archives`
  )
  return data ?? null
}
